<template>
  <v-flex xs12>
    <v-data-table
      :headers="headers"
      :rows-per-page-items="[25, 50, 100]"
      rows-per-page-text="Registros por página"
      :items="concepts"
      :loading="working.wConcepts"
      :pagination.sync="pagination"
      :total-items="totalItemsFromBackend"
      item-key="id"
      no-results-text="No se encontraron coincidencias"
      :no-data-text="permits['WATCH_PAYMENTS_CONCEPTS'] ? (working.wConcepts ? 'Cargando' : (concepts.length > 0 ? '' : 'No hay conceptos de pago')) : 'No tienes permiso de ver conceptos de pago'"
    >
      <template v-slot:headers>
        <tr>
          <th
            class="text-xs-left"
            style="width: 700px; max-width: 700px; min-width: 700px;"
          >Concepto</th>
          <th class="text-xs-right" style="width: 120px; max-width: 120px; min-width: 120px;">Monto</th>
          <th
            class="text-xs-right"
            style="width: 120px; max-width: 120px; min-width: 120px;"
          >Recargos</th>
          <th class="text-xs-left" style="width: 170px; max-width: 170px; min-width: 170px;">Creado</th>
          <th style="width: 160px; max-width: 160px; min-width: 160px;">&nbsp;</th>
        </tr>
      </template>
      <template v-slot:items="props">
        <td
          class="text-xs-left"
          style="width: 700px; max-width: 700px; min-width: 700px;"
        >{{ props.item.name }}</td>
        <td
          class="text-xs-right"
          style="width: 120px; max-width: 120px; min-width: 120px;"
        >{{ props.item.amount | formatCurrency }}</td>
        <td
          class="text-xs-right"
          style="width: 120px; max-width: 120px; min-width: 120px;"
        >{{ props.item.penalty | formatCurrency }}</td>
        <td
          class="text-xs-left"
          style="width: 170px; max-width: 170px; min-width: 170px;"
        >{{ props.item.createdAt | formatDateShort }}</td>
        <td style="width: 160px; max-width: 160px; min-width: 160px;">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs" v-on="on"
                @click="editPayment(props.item)"
                icon
                :disabled="!permits['UPDATE_PAYMENTS_CONCEPTS']"
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </template>
            <span>Editar Concepto</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs" v-on="on"
                @click="deleteConcept(props.item)"
                icon
                :disabled="!(permits['UPDATE_PAYMENTS_CONCEPTS'] && props.item.editable)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <span>Eliminar Concepto</span>
          </v-tooltip>
        </td>
      </template>
      <template
        v-slot:pageText="props"
      >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
    </v-data-table>

    <PaymentConceptModal
      :title="modals.title"
      v-model="modals.concept"
      :concept="concept"
      @created="onNewConcept"
      @updated="onUpdateConcept"
      @cancelled="onCancel"
    />
    <desition
      @desition="($event) ? onDeletedConcept(): onCancel()"
      v-model="modals.confirmDelete"
      title="Eliminar concepto"
      description="¿Está seguro que desea realizar dicha acción, este proceso es irreversible y no podrá recuperar la información?"
    />
    <loading v-model="working.wLoading" text="Trabajando" />
    <success v-model="toast.success" text="Operación exitosa" />
    <error v-model="toast.failed" text="No fue posible eliminar el concepto de pago" />
  </v-flex>
</template>

<script>
import loading from "../../Dialogs/Loading";
import success from "../../Dialogs/Success";
import error from "../../Dialogs/Error";
import PaymentConceptModal from "../../Modals/PaymentConceptModal";
import desition from "../../Dialogs/Confirm";

export default {
  components: {
    PaymentConceptModal,
    loading,
    success,
    error,
    desition,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    showAddForm: {
      type: Boolean,
      required: true,
      default: false,
    },
    search: {
      type: String,
      required: true,
      default: "",
    },
  },
  data: () => ({
    pagination: {
      sortBy: "name",
    },
    filters: {
      search: "",
    },
    working: {
      wConcepts: false,
      wLoading: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    concepts: [],
    totalItemsFromBackend: 0,
    headers: [
      {
        text: "Concepto",
        align: "left",
        value: "name",
        filterItems: [],
      },
      {
        text: "Monto",
        value: "amount",
        align: "right",
        filterItems: [],
      },
      {
        text: "Recargos",
        value: "penalty",
        filterItems: [],
        align: "right",
      },
      {
        text: "Creado",
        value: "createdAt",
        filterItems: [],
        align: "left",
      },
      {
        text: "",
        value: "id",
        filterItems: [],
        align: "center",
      },
    ],
    concept: null,
    modals: {
      title: "",
      concept: false,
      import: false,
      confirmDelete: false,
    },
    permits: [],
  }),
  watch: {
    showAddForm() {
      if (this.showAddForm) {
        this.addPayment();
      }
    },
    user() {
      if (this.user.id) this.mapPermits();
      if (
        this.permits["WATCH_PAYMENTS_CONCEPTS"] &&
        !this.concepts.length > 0
      ) {
        this.getConcepts();
      }
    },
    search() {
      if (!this.working.wConcepts) {
        this.filters.search = this.search;
        this.getConcepts();
      }
    },
    pagination: {
      handler() {
        if (this.permits["WATCH_PAYMENTS_CONCEPTS"]) {
          this.getConcepts();
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.user.id) this.mapPermits();
    if (this.permits["WATCH_PAYMENTS_CONCEPTS"] && !this.concepts.length > 0) {
      this.getConcepts();
    }
  },
  methods: {
    mapPermits() {
      var usr = this.user;
      var wbRol = usr.webRole;
      var catalogs = wbRol.catalogs;
      for (var c in catalogs) {
        if (catalogs[c].name.includes("PAYMENTS_CONCEPTS")) {
          this.permits[catalogs[c].name] = 1;
        }
      }
      this.loading = this.permits["WATCH_PAYMENTS_CONCEPTS"] ? true : false;
    },
    addPayment() {
      this.concept = null;
      this.modals.title = "Crear concepto";
      this.modals.concept = true;
    },
    onNewConcept(event) {
      event.new = true;
      this.concepts.unshift(event);
      this.modals.concept = false;
      this.$forceUpdate();
      this.$emit("closedPopup");
    },
    editPayment(concept) {
      this.concept = concept;
      this.modals.concept = true;
      this.modals.title = "Editar concepto";
    },
    onUpdateConcept(event) {
      this.concepts.splice(this.concepts.indexOf(this.concept), 1, event);
      this.concept = null;
      this.modals.concept = false;
      this.$forceUpdate();
    },
    onCancel() {
      this.concept = null;
      this.modals.concept = false;
      this.modals.confirmDelete = false;
      this.$forceUpdate();
      this.$emit("closedPopup");
    },
    deleteConcept(concept) {
      this.concept = concept;
      this.modals.confirmDelete = true;
    },
    getConcepts() {
      var offset = (this.pagination.page - 1) * this.pagination.rowsPerPage;
      this.working.wConcepts = true;
      this.$store
        .dispatch("paymentConcepts/getConcepts", {
          search: this.filters.search,
          page_size: this.pagination.rowsPerPage, 
          offset: offset
        })
        .then((response) => {
          this.working.wConcepts = false;
          this.concepts = response.data.items;
          this.totalItemsFromBackend = response.data.total;
        })
        .catch(() => {
          this.working.wConcepts = false;
        });
    },
    onDeletedConcept() {
      this.working.wLoading = true;
      this.$store
        .dispatch("paymentConcepts/deleteConcept", this.concept.id)
        .then((response) => {
          this.working.wLoading = false;
          this.toast.success = true;
          this.getConcepts();
        })
        .catch((error) => {
          this.working.wLoading = false;
          this.toast.failed = true;
        });
    },
  },
};
</script>

<style>
</style>